// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, IntlContext, IntlShape } from "react-intl";

import { TrendMonitor as ITrendMonitor } from "shared/types/cloudtypes";
import TrendMonitorModel from "model/trendmonitor";
import { IState } from "states/states";
import { getSiteSelection } from "guiutils";
import { isSet } from "shared/utils/utils";

import TrendMonitorGraph from "view/comp/TrendMonitorGraph";
import TrendHeading from "view/comp/TrendHeading";
import TrendMonitorSelect from "view/comp/TrendMonitorSelect";
import TrendSiteBar from "view/comp/TrendSiteBar";

interface ITrendMonitorExProps {
  isDashboard?: boolean;
}
interface ITrendMonitorProps {
  selectedMonitor: number | undefined;
  trendMonitors: ITrendMonitor[];
}

const mapStateToProps = (state: IState) => {
  const site = state.site.siteList?.find((curSite) => curSite.id === state.cached.selectedSite);
  const trendMonitors = site?.cloudSettings?.trendMonitor ?? [];
  const idxs = TrendMonitorModel.getActiveSortedTrendMonitorIdxs(trendMonitors);

  const props: ITrendMonitorProps = {
    selectedMonitor: getSiteSelection(state)?.trendMonitor ?? idxs[0],
    trendMonitors,
  };
  return props;
};

const messages = defineMessages({
  graphTitle: {
    id: "TrendGraphTitle",
    defaultMessage: "Trend Monitor",
  },
});

class TrendMonitorComponent extends React.Component<ITrendMonitorProps & ITrendMonitorExProps> {
  static contextType = IntlContext;
  declare context: IntlShape;

  public render() {
    const trendMonitor = this.props.trendMonitors[this.props.selectedMonitor!] as
      ITrendMonitor | undefined;
    return (
      <>
        {this.props.isDashboard !== true && <TrendSiteBar showPeriodSelect={true} />}
        <div id="trendmonitor" className="flex-self flex-content graph-shrink">
          {this.props.isDashboard !== true && (
            <div className="headerbuttons mb-2">
              <div className="left">
                <TrendMonitorSelect />
              </div>
            </div>
          )}
          {this.props.isDashboard !== true && (
            <TrendHeading
              identifier="trendPeriod"
              includeDate={true}
              title={this.context.formatMessage(messages.graphTitle)}
            />
          )}
          {isSet(trendMonitor) && <TrendMonitorGraph />}
        </div>
      </>
    );
  }
}

const TrendMonitor = connect(mapStateToProps)(TrendMonitorComponent);

export default TrendMonitor;
